/*
 * Shopify Common JS
 *
 */

var headerHeight;
var headerEle;

if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @return {String} value - formatted value
 */
Shopify.formatMoney = function (cents, format) {
    if (format == null || format == undefined) {
        format = window.globalVariables.money_format || "$";
    }
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {

        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};

let productSlider = null;
window.scrollTopPos = window.pageYOffset || document.documentElement.scrollTop;

if (typeof Utility != 'undefined') Utility.manageAnimationClass();
manageTopBar();

/**
 * Set root variable for mobile navigation top
 * Submenu Body click event to stop closing second level
 */
setTimeout(() => {
    updateTopinRoot();
}, 300);

let accessCookie = Utility.getCookie('customerAccessToken');
if (globalVariables.customer == null && (accessCookie != null) && accessCookie != '') {
    document.cookie = 'customerAccessToken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function updateTopinRoot() {
    headerEle = document.querySelector('.site-header');
    if (headerEle != undefined) {
        headerHeight = headerEle.clientHeight;
        document.documentElement.style.setProperty('--bs-navdrawer', `${headerHeight}px`);
    }
    if (document.querySelector('.header-slider-desktop')) {
        let w = window.innerWidth;
        if (w < 768) {
            let finalH = window.innerHeight - headerHeight;
            document.querySelector(".header-slider-desktop").style.height = (finalH) + "px";
        }
    }
    if (document.querySelector('.topbar')) {
        document.getElementsByTagName("BODY")[0].classList.add('body-topbar');
        var topbar_height = document.querySelector("#header-topbar").offsetHeight;
        document.documentElement.style.setProperty('--bs-topnav', `${topbar_height}px`);
        // alert(topbar_height)
    }
}

function manageTopBar() {
    let topBarEle = document.querySelector('header [data-top-bar]');
    let hideAnnouncement = document.querySelector('[data-closeAnnouncement]');

    if (hideAnnouncement) {
        hideAnnouncement.addEventListener('click', (e) => {
            e.preventDefault();
            topBarEle.style.height = 0;
            Utility.setCookie('hide_topbar', true, 7);
            topBarEle.classList.add('d-none');
            setTimeout(() => {
                updateTopinRoot();
            }, 300);
        })
    }
}

/**
 * prevent body Touch event in Touch devices when Overlay is visible
 *
 * @param {event} event - event instance
 */
function bodyTouchMove(event) {
    let currentTarget = event.target;
    if (!currentTarget.closest('[data-touch-moveable]')) {
        event.preventDefault();
    }
}

/**
 * Limit the number of times a function is called within defined timeout
 *
 * @param {form} form - Form to serialize
 */
const serializeForm = (form, ignore) => {
    const obj = {};
    const formData = new FormData(form);

    for (const key of formData.keys()) {
        const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
        if (regex.test(key)) {
          if(key !== ignore){
            obj.properties = obj.properties || {};
            obj.properties[regex.exec(key)[2]] = formData.get(key);
          }
        } else {
          if(key !== ignore){
            obj[key] = formData.get(key);
          }
        }
    }

    return JSON.stringify(obj);
};

/**
 * Fetch call config
 *
 * @param {string} type - request Accept type
 */
function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
    };
}

/**
 * Open Modal javscript trigger
 *
 * */
function openModal(modal, opener) {
    if (modal && opener != undefined) modal.show(opener);
}

/**
 * Dropdown component Events and Methods
 *
 * @param {element} element - Dropdown element
 */
function dropDownInit(element) {

    let dropdownParent = element.parentElement;
    const _this = element;

    let closeBtns = dropdownParent.querySelectorAll('.close-submenu');
    closeBtns.forEach((btn) => {
        btn.addEventListener('click', (event) => {
            event.stopPropagation();
            let parentElement = event.currentTarget.closest('.dropdown');
            dropdownToggle(dropdownParent);
        });
    });

    ["mouseover", "focusin", "click", "mouseout"].forEach(function (type) {
        if (type == 'click' || type == 'touchend') {
            dropdownParent.addEventListener(type, (e) => {
                e.stopPropagation();
                let currentTarget = e.currentTarget;
                let liveTarget = e.target;
                /* if(e.target.classList.contains('nav-link-title')){
                  let linkHref = currentTarget.querySelector('.nav-link').getAttribute('data-href');
                  if(linkHref) window.location.href = linkHref;
                }else{ */

                if (liveTarget && !liveTarget.closest('[data-touch-moveable]') || type == 'click' || type == 'touchend') {
                    dropdownToggle(dropdownParent);
                } else {
                    dropdownToggle(dropdownParent);
                }
                // }
            });
        } else if (type == 'mouseout') {
          if(dropdownParent.getAttribute('data-mobile') !== 'true') {
            dropdownParent.addEventListener(type, (e) => {
                let currentTarget = e.currentTarget;
                if (!currentTarget.closest('[data-touch-moveable]')) {
                    e.stopPropagation();
                    dropdownHide(dropdownParent);
                }
            });
          }
        } else if (type == 'mouseover' || type == 'focusin') {
          if(dropdownParent.getAttribute('data-mobile') !== 'true') {
            dropdownParent.addEventListener(type, (e) => {
                let currentTarget = e.currentTarget;
                if (!currentTarget.closest('[data-touch-moveable]')) {
                    dropdownShow(dropdownParent);
                }
            });
            _this.addEventListener(type, (e) => {
                ChildonFocusChange(dropdownParent);
            });
          }
        }
    });

    dropdownParent.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
            dropdownHide(event.currentTarget);
        }
        if (event.code.toUpperCase() === 'ENTER') {
            dropdownShow(event.currentTarget);
        }
    });

    function dropdownToggle(dropdownParent) {
        let isActive = dropdownParent.classList.contains('open');
        setTimeout(function () {
            if (!isActive) {
              try{
                dropdownHide(dropdownParent.closest('ul').querySelector('.open'));
              }catch{}
                dropdownShow(dropdownParent);
            } else if (isActive) {
                dropdownHide(dropdownParent);
            }
        }, 0);
    }

    function dropdownShow(dropdownParent) {
        _this.setAttribute('aria-expanded', true);
        if (!dropdownParent.closest('[data-role="drawer"]')) {
            dropdownParent.classList.add('open');
        } else {
            Utility.toggleElement(dropdownParent, 'open');
        }
    }

    function dropdownHide(dropdownParent) {
        _this.setAttribute('aria-expanded', false);
        if (!dropdownParent) {
            return;
        }

        if (!dropdownParent.closest('[data-role="drawer"]')) {
            dropdownParent.classList.remove('open');
        } else {
            Utility.toggleElement(dropdownParent, 'close');
        }
        if (event && event.type == 'mouseout' && dropdownParent.parentElement.closest('.dropdown')) {
            dropdownParent.parentElement.closest('.dropdown').classList.remove('open');
        }

        let childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
        if (childDropdowns.length > 0) {
            childDropdowns.forEach(function (child) {
                child.classList.remove('open');
                if (child.querySelector('a[data-toggle="open"]'))
                    child.querySelector('a[data-toggle="open"]').setAttribute('aria-expanded', false);
            });
        }
    }

    function ChildonFocusChange(dropdownParent) {
        let _this = this;
        let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
        let currentIndex = openDropdowns.indexOf(dropdownParent);
        openDropdowns.forEach((ele) => {
            let eleIndex = openDropdowns.indexOf(ele);
            if (eleIndex != currentIndex) {
                dropdownHide(ele);
            }
        });
    }
}

function menuHover(element) {
  let el = element;
  let dropdownMenu = el.closest('.dropdown-menu');
  let imageEl = dropdownMenu.querySelector('.drowndown-menu-column--image img');
  let titleEl = dropdownMenu.querySelector('.dropdown-menu-title');
  let urlEl = dropdownMenu.querySelector('.drowndown-menu-column--image a');

  ["mouseover", "focusin"].forEach(function (type) {
    el.addEventListener(type, (e) => {
        let currentTarget = e.currentTarget;
        if(currentTarget.dataset.image != ''){
          imageEl.src = currentTarget.dataset.image;
          imageEl.srcset = currentTarget.dataset.image;
          titleEl.innerHTML = currentTarget.dataset.title;
          urlEl.href = currentTarget.dataset.url;
        }
    });
  })
}

const allHovers = document.querySelectorAll('.js-hover');
allHovers.forEach(function(ele) {
  menuHover(ele);
})


const allDropdowns = document.querySelectorAll('a[is="drop-down"]');
allDropdowns.forEach(function (ele) {
    dropDownInit(ele)
});

/**
 * Close SubMenu Dropdowns on Regular Nav Item fous or click
 *
 * @param {element} element - Dropdown element
 */
function defaultNavItem(element) {
    let _this = element;
    ["focusin", "click", "mouseover", "mouseout"].forEach(function (type) {
        _this.addEventListener(type, (e) => {
            let currentTarget = e.currentTarget;
            if (!currentTarget.closest('[data-touch-moveable]')) {
                hideDropdown(_this.parentElement);
            }
        });
    });

    ["click", "touchend"].forEach(function (type) {
        _this.addEventListener(type, (e) => {
            e.stopPropagation();
        });
    });

    function hideDropdown(dropdownParent) {
        let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
        openDropdowns.forEach((ele) => {
            ele.classList.remove('open');
            ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
        });
    }
}

const allDefaultNav = document.querySelectorAll('a[is="simple-menu-item"]');
allDefaultNav.forEach(function (ele) {
    defaultNavItem(ele);
});

/**
 * Mobile Navigation Drawer
 */
class MobileNavigation extends HTMLElement {
    constructor() {
        super();

        this.touchstartX = 0;
        this.touchendX = 0;

        this.openeBy = document.querySelector('#mobile-menu');
        this.closeBy = this.querySelector('.close-mobile--navbar');
        this.headerCloseBy = document.querySelector('#mobile-close-menu');
        this.navDrawer = this.querySelector('#mobile-menu-drawer');
        this.bindEvents();
    }

    /**
     * Focus Out Event to close drawer
     *
     * @param {event} Event instance
     */
    focusOut(event) {
        let isOpen = this.navDrawer.classList.contains('opened-drawer');
        if (!this.contains(event.relatedTarget) && isOpen == true) {
            this.headerCloseBy.dispatchEvent(new Event('click'));
        }
    }

    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.headerCloseBy.dispatchEvent(new Event('click'));
    }

    /**
     * bind click event to Menu Icon
     * bind keyup event to Menu Drawer component
     */
    bindEvents() {
        this.openeBy.addEventListener('click', this.openMenuDrawer.bind(this));
        this.headerCloseBy.addEventListener('click', this.closeMenuDrawer.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
    }

    /**
     * Open Menu Drawer
     *
     * @param {event} Event instance
     */
    openMenuDrawer(event) {
        this.navDrawer.classList.add('opened-drawer');
        let cartDrawer = document.querySelector('ajax-cart.cart-drawer');
        if (cartDrawer && cartDrawer.classList.contains('opened-drawer')) {
            document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
        }
        if (event) {
            // updateTopinRoot();
            event.preventDefault();
            let openBy = event.currentTarget;
            openBy.setAttribute('aria-expanded', true);
            Utility.trapFocus(this.navDrawer, this.querySelector('.mobile-btn-sub'));
            Utility.forceFocus(this.querySelector('.mobile-btn-sub'));
            document.body.classList.add('mobile-nav-open');
            siteOverlay.prototype.showOverlay();
        }
    }

    /**
     * Close Menu Drawer
     *
     * @param {event} Event instance
     */
    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            event.preventDefault();
            this.navDrawer.classList.remove('opened-drawer');
            this.openeBy.setAttribute('aria-expanded', false);
            Utility.forceFocus(this.openeBy);

            let openDropdowns = Array.from(document.querySelectorAll('#mobile-menu-drawer .dropdown.open, #mobile-menu-drawer .submenu.open'));
            openDropdowns.forEach((ele) => {
                ele.classList.remove('open');
                try{
                  ele.querySelector('[data-type="content"]').classList.remove('overflow-visible');
                }catch{}
                if (ele.querySelector('[is="drop-down"]')) ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
            });

            document.body.classList.remove('mobile-nav-open');
            siteOverlay.prototype.hideOverlay();
        }
    }
}
customElements.define("mobile-nav", MobileNavigation);

/**
 * Modal Dialogue
 *
 */
class ModalDialog extends HTMLElement {
    constructor() {
        super();

        this.modal = this.querySelector('.modal');
        this.modalOpeners = document.querySelectorAll('[data-modal-opener="' + this.id + '"]');
        if (this.modalOpeners.length > 0) {
            this.modalOpeners.forEach((opener) => {
                opener.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.show(opener);
                });
            });
        }

        if (this.querySelector('[id^="ModalClose-"]')) {
            this.querySelector('[id^="ModalClose-"]').addEventListener(
                'click',
                this.hide.bind(this)
            );
            try{
              this.querySelector('.js-close-ip').addEventListener('click', this.hide.bind(this));
            }catch{}
        }

        this.addEventListener('click', (event) => {
            if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
        });

        this.addEventListener('keyup', () => {
            if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
        });

        this.modal.addEventListener('click', this.hide.bind(this));
        this.querySelector('.modal-content').addEventListener('click', (event) => {
            event.stopPropagation();
        });
    }

    show(opener) {
        this.openedBy = opener;
        this.modal.classList.add('open');
        siteOverlay.prototype.showOverlay();
        Utility.trapFocus(this);
        Utility.forceFocus(this.querySelector('[id^="ModalClose-"]'));
    }

    hide() {
      try{

        let type = document.querySelector('[data-box-type]').getAttribute('data-box-type');
        sessionStorage.setItem(`${type}`, "1");
      }catch{}
        document.body.classList.remove('overflow-hidden');
        this.modal.classList.remove('open');
        try{this.modal.closest('section').classList.remove('shown');}catch{};
        siteOverlay.prototype.hideOverlay();
        Utility.removeTrapFocus(this.openedBy);

        if (this.id == 'PopupModal-video' && document.getElementsByTagName('custom-video')) {
          this.querySelector('.video-section').innerHTML = '';
          if (document.querySelector('custom-video') != null) {
              document.querySelector('custom-video').classList.remove('show--video');
          }
        }
        if (this.id == 'PopupModal-notifyme') {
            this.querySelector('form [name="email"]').value = '';
            this.querySelector('[data-bodyjson]').innerHTML = '';
        }
    }
}
customElements.define('modal-dialog', ModalDialog);

/**
 * Website Overlay for Mobile Menu and Cart Drawer
 */
class siteOverlay extends HTMLElement {
    constructor() {
        super();

        this.menuDrawer = document.querySelector('#mobile-menu-drawer');
        this.cartDrawer = document.querySelector('ajax-cart.cart-drawer');
        this.filterDrawer = document.querySelector('#filtersCollapse');
        this.popup = document.querySelector('.js-popup');
        this.bindEvents();
    }

    /**
     * bind Click and Touchend event to this custom component
     */
    bindEvents() {
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('touchend', this.onClick.bind(this));
    }

    /**
     * Click event of Site overlay
     * @param {event} Event instance performed
     */
    onClick(event) {
        if (this.cartDrawer && this.cartDrawer.classList.contains('opened-drawer')) {
            document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
        }
        if (this.menuDrawer && this.menuDrawer.classList.contains('opened-drawer')) {
            document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
        }

        if (this.filterDrawer && this.filterDrawer.classList.contains('filter-active')) {
            document.querySelector('.collection-filters-close').dispatchEvent(new Event('click'));
        }

        if (this.popup && this.popup.classList.contains('open')) {
          document.querySelector('.js-close').dispatchEvent(new Event('click'));
        }
        
        this.hideOverlay();
    }

    /**
     * Show Overlay
     */
    showOverlay() {
        window.scrollTopPos = window.pageYOffset || document.documentElement.scrollTop;
        document.getElementById('site-overlay').classList.add('overlay--body');
        // document.documentElement.style.setProperty('--bs-scrollTop',`-${window.scrollTopPos}px`);
        // document.documentElement.style.setProperty('--bs-headerTop',`${window.scrollTopPos}px`);
        document.body.classList.add('overflow--hidden');
        /*if(window.scrollTopPos > 0){
          let headerSection = document.querySelector('.site-header');
          if(headerSection) headerSection.classList.add('header-sticky');
        }*/
        document.body.addEventListener('touchmove', bodyTouchMove, false);
    }

    /**
     * Hide overlay
     */
    hideOverlay() {
        document.getElementById('site-overlay').classList.remove('overlay--body');
        document.body.classList.remove('overflow--hidden');
        // if(window.innerWidth < 767){
        //   window.scroll({
        //     top: window.scrollTopPos
        //   });
        // }
        /* let headerSection = document.querySelector('.site-header');
        if(headerSection) headerSection.classList.remove('header-sticky'); */
        document.body.removeEventListener('touchmove', bodyTouchMove, false);
    }
}
customElements.define("site-overlay", siteOverlay);/**
 * Tab HTML
 */
class customTabs extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('.tablink').forEach(
            link => link.addEventListener('click', this.toggleTabs.bind(this))
        );

        let gifFlowEnabled = window.localStorage.getItem("recharge_gift_flow") === "yes";
        if (gifFlowEnabled) {
            document.getElementById('account-gift-tab').click();
            window.localStorage.setItem("recharge_gift_flow", "no");
        }
    }

    /**
     * Toggle Tabs on link click
     *
     * @param {event} Event instance
     */
    toggleTabs(event) {
        if(event.target.dataset.url){
          window.location.href = event.target.dataset.url;
        }
        event.preventDefault();
        event.stopPropagation();
        const currentTab = event.currentTarget;
        const tabLink = currentTab.querySelector('[data-toggle="tab"]');
        const tabContainer = document.querySelector(tabLink.dataset.tabcontent);
        this.openTab(currentTab, tabContainer)
    }

    /**
     * Open Tab Container
     *
     * @param {Node} currentTab Tab Container Open link
     * @param {Node} tabContainer Tab Container to open
     */
    openTab(currentTab, tabContainer) {
        //close open form/tabs
        currentTab.parentNode.querySelectorAll('.tablink').forEach(tablink => {
            tablink.classList.remove('open');
        });
        tabContainer.parentNode.querySelectorAll('.tabcontent').forEach(container => {
            container.classList.remove('open');
            const form = container.querySelector('product-form');
            if (form) {
                form.classList.remove('not-fixed');
                form.classList.remove('fixed');
                form.classList.remove('first-scroll');
            }
            const linkEle = container.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#' + container.id + '"]');
            if (linkEle) {
                linkEle.setAttribute('aria-expanded', false);
                if (linkEle.closest('.tablink')) {
                    linkEle.closest('.tablink').classList.remove('open');
                }
            }
        });

        //open selected tab
        currentTab.classList.add('open');
        currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
        tabContainer.classList.add('open');
    }

    /**
     * Close Tab Container
     *
     * @param {Node} currentTab Tab Container link
     * @param {Node} tabContainer Tab Container to close
     */
    closeTab(currentTab, tabContainer) {
        currentTab.classList.remove('open');
        currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', false);
        tabContainer.classList.remove('open');
    }
}
customElements.define("custom-tabs", customTabs);/**
 * Accordion HTML
 */
class customAccordion extends HTMLElement {
    constructor() {
        super();
        this.accordionType = this.dataset.accordiontype;
        this.toggleBtns = this.querySelectorAll('.accordion__toggle');

        this.toggleBtns.forEach(button => button.addEventListener('click', this.toggleAccordionBlock.bind(this)));
    }

    /**
     * Focus Out Event to close drawer
     *
     * @param {event} Event instance
     */
    focusOut(event) {

    }

    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
    }

    /**
     * Toggle Tabs on link click
     *
     * @param {event} Event instance
     */
    toggleAccordionBlock(event) {
        event.preventDefault();
        const toggleBtn = event.currentTarget;
        const targetContainer = toggleBtn.parentNode;
        const isOpen = targetContainer.classList.contains('open');
        isOpen ? this.closeAccordionBlock(toggleBtn) : this.openAccordionBlock(toggleBtn);
    }

    /**
     * @param toggleBtn
     */
    openAccordionBlock(toggleBtn) {
        let targetContainer = toggleBtn.parentNode;
        toggleBtn.setAttribute('aria-expanded', true);
        Utility.toggleElement(targetContainer, 'open');
        if (this.accordionType == 'single') {
            let siblingBlocks = targetContainer.parentNode.querySelectorAll('.accordion__container');
            siblingBlocks.forEach(sibling => {
                if (sibling === targetContainer) {
                    return;
                }
                if (sibling.classList.contains('open')) {
                    this.closeAccordionBlock(sibling.querySelector('.accordion__toggle'))
                }
            });
        }
        Utility.trapFocus(targetContainer);
    }

    /**
     * @param toggleFilterBtn
     */
    closeAccordionBlock(toggleFilterBtn) {
        const targetContainer = toggleFilterBtn.parentNode;
        toggleFilterBtn.setAttribute('aria-expanded', false);
        Utility.toggleElement(targetContainer, 'close');
        Utility.removeTrapFocus(targetContainer);
    }
}
customElements.define("custom-accordion", customAccordion);class customSelect extends HTMLElement {
    constructor() {
        super();

        this.selectContainer = this.querySelector('.custom--select');
        this.select = this.querySelector('ul');
        this.initOption = this.querySelector('.default');
        this.options = this.select.querySelectorAll('li');

        this.debouncedOnChange = Utility.debounce((event) => {
            this.toggleOptions(event);
        }, 500);

        this.options.forEach(option => option.addEventListener('click', this.debouncedOnChange.bind(this)));
        this.initOption.addEventListener('click', this.manageVisibility.bind(this));

        this.addEventListener('click', (event) => {
            event.stopPropagation();
        });
        document.body.addEventListener('click', () => {
            Utility.toggleElement(this, 'close');
            Utility.toggleElement(this.selectContainer, 'close');
        });
    }

    toggleOptions(event) {
        let _this = event.target;
        if (_this.nodeName != 'LI') _this = event.target.closest('li');
        this.options.forEach(option => option.classList.remove('selected'));
        _this.classList.add('selected');
        if (_this.querySelector('.option_txt') != null) {
            this.initOption.querySelector('.option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;

        }

        /* Collection Page Sortby value update in form on option Toggle */
        let sortBySelect = this.classList.contains('sortby-dropdown');
        if (sortBySelect) {
            let selectedOption = this.selectContainer.querySelector('input[type="radio"]:checked');
            let filterForm = document.querySelector('#CollectionFiltersForm');
            if (selectedOption && filterForm) {
                let sortByInput = filterForm.querySelector('input[name="sort_by"]');
                sortByInput.value = selectedOption.value;

                filterForm.dispatchEvent(new Event('input', {
                    bubbles: false,
                    cancelable: true,
                }));
            }
        }
        /* End of Collection Page Sortby value update in form on option Toggle */
        Utility.toggleElement(this, 'close');
        Utility.toggleElement(this.selectContainer, 'close');
    }

    manageVisibility(event) {
        let isOpen = this.selectContainer.classList.contains('open');
        let isOpenMain = this.classList.contains('open');

        isOpen ? Utility.toggleElement(this.selectContainer, 'close') : Utility.toggleElement(this.selectContainer, 'open');
        isOpenMain ? Utility.toggleElement(this, 'close') : Utility.toggleElement(this, 'open');
    }
}
customElements.define('custom-select', customSelect);/**
 * Custom Video
 */
class customVideo extends HTMLElement {
    constructor() {
      super();
      
      this.container = this.closest('.custom-video-container');
      this.videoModal = document.getElementById('PopupModal-video');
      this.triggerVideo = this.querySelector('[data-trigger-video]') || document.querySelector("[data-box-video]");
      this.pauseVideo = this.querySelector('[data-pause-video]');
      this.fullWidthTriggerBtn = (this.container) ? this.container.querySelectorAll('[data-trigger-videobtn]') : null;
      this.placementType = this.getAttribute('data-placement');
      this.type = this.getAttribute('data-video-type');
      console.log(this.type, this.placementType, 'loaded')
        if(this.type === "youtube"){

          console.log('youtube')

            // Load the IFrame Player API code asynchronously
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
        this.videoID = this.getAttribute('data-video-id');
        // this.contentSection = this.querySelector('.content-section');
        this.videoSection = this.querySelector('.video-section');
        if (this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-section');

        if (window.screen.width <= 767 && this.dataset.mobilevideo) {
            this.videoID = this.dataset.mobilevideo;
        }

        this.bindEvents();
    }

    bindEvents() {
        if (this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
        if (this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
        if (this.fullWidthTriggerBtn) {
            this.fullWidthTriggerBtn.forEach(item => {item.addEventListener('click', (e) => {
                e.preventDefault();
                if(e.target.getAttribute('data-tab-link')){
                    window.open(e.target.getAttribute('data-tab-link'), '_blank');
                } else {
                    this.triggerVideo.dispatchEvent(new Event('click'));
                }
            })
            });
        }
    }

    /**
     * Focus Out Event to close drawer
     *
     * @param {event} Event instance
     */
    focusOut(event) {
        if (this.placementType == 'popup' && this.classList.contains('show--video')) this.toggleView();
    }

    toggleView() {
        let isOpen = this.classList.contains('show--video');
        let _this = this;
        if (isOpen) {
            if(!this.type == "youtube"){
              this.videoSection.innerHTML = '';
            }
            this.classList.remove('show--video');
            setTimeout(() => {
                if (this.container) this.container.classList.remove('playing--video', 'video--playing', 'video--paused');
            }, 500);
        } else {
          let videoID = 'custom-video' + Math.floor((Math.random() * 100) + 1);
          if(!this.container?.querySelector('.video-section')?.querySelector('video')){
            const videoElement = this._buildVideo(videoID);
            videoElement.id = videoID;
                this.videoSection.appendChild(videoElement);
              this.classList.add('show--video');
              if (this.placementType == 'popup') {
                  openModal(this.videoModal, this.triggerVideo)
              } else if (this.container) {
                  this.container.classList.add('playing--video');
              }

              this.manageOnScroll();
              if (this.type == 'local') {
                  this.playPauseEvent(videoElement);
              }
          }
          else{
            this.container.querySelector('.video-section').querySelector('video').play();
          }
        }
    }



    _buildVideo(videoElId) {
        let video;
        if (window.screen.width <= 767 && this.dataset.mobilevideo) {
            this.videoID = this.dataset.mobilevideo;
        }
        if (this.type == 'local') {
            video = document.createElement('video');
            video.src = this.videoID;
            if (this.dataset.autoplay == 'true') video.autoplay = this.dataset.autoplay;
            if (this.dataset.controls == 'true') video.controls = this.dataset.controls;
            if (this.dataset.controls == 'true') {
              console.log(video.hasAttribute('controls'), 'asdf')
              if(video.hasAttribute('controls')){

              }else{
                video.addEventListener('touchstart', () => {
                  video.controls = this.dataset.controls
                })
              }
            }
            if (this.dataset.muted == 'true') video.muted = this.dataset.muted;
            if (this.dataset.loop == 'true') video.loop = this.dataset.loop;
            video.setAttribute('playsinline', '')
        } else if (this.type == 'youtube') {
            video = document.createElement("div");
            video.id = videoElId;
            let videoId = this.videoID;
            let player;
            this.videoSection?.appendChild(video);
            // Create an <iframe> (and YouTube player) after the API code downloads
            function onYouTubeIframeAPIReady() {
                player = new YT.Player(`${videoElId}`, {
                    height: '450',
                    width: '100%',
                    videoId: videoId,  // Replace with actual video ID
                    playerVars: {
                        'autoplay': 1,  // Initially not autoplaying
                        'mute': 1,      // Unmuted
                        'controls': 1
                    },
                    events: {
                      'onReady': onPlayerReady
                    }
                });
                function onPlayerReady(event) {
                  event.target.unMute();
                }
            }
            try{

              onYouTubeIframeAPIReady();
            }catch{}
            // video.setAttribute("allowfullscreen", "");
            // video.setAttribute("frameborder", "0");
            // video.playsinline;
            // video.setAttribute("src", "https://www.youtube.com/embed/" + this.videoID + `?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&mute=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${this.videoID}&enablejsapi=1&origin=${window.origin}`);
        } else if (this.type == 'vimeo') {
            video = document.createElement("iframe");
            video.setAttribute("allowfullscreen", "");
            video.setAttribute("frameborder", "0");
            video.setAttribute("src", "https://player.vimeo.com/video/" + this.videoID + `?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&mute=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${this.videoID}`);
        }
        return video;
    }

    playPauseEvent(video) {
        const _this = this;
        if (this.type == 'youtube') {
            //  Code added after this component
        }
        if (this.type == 'local') {
            if (_this.pauseVideo) {
                _this.pauseVideo.addEventListener('click', (e) => {
                    video.play();
                });
            }
            video.onplay = function (e) {
                if (_this.container) {
                    _this.container.classList.add('video--playing');
                    _this.container.classList.remove('video--paused');
                }
            };
            video.onpause = function (e) {
                if (_this.container) {
                    _this.container.classList.add('video--paused');
                    _this.container.classList.remove('video--playing');
                }
            };
            video.onended = function (e) {
                _this.container.classList.remove('playing--video', 'video--playing', 'video--paused');
                _this.classList.remove('show--video');
                video.currentTime = 0;
                video.closest('.custom-video-container').classList.add('done');
            };
        }
    }

    manageOnScroll() {
      let video = this.querySelector('video') || this.querySelector('iframe');
        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio == 0) {
                    if (this.type == 'local') {
                        video.pause();
                    } else if (this.type == 'youtube' && video.contentWindow) {
                        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                    }
                }
            });
        });
        if (video != undefined) observer.observe(video);
    }
}
customElements.define("custom-video", customVideo);/**
 * Slider Component
 *
 */
class sliderElement extends HTMLElement {
    constructor() {
        super();
        let sliderElement = this.querySelector('.swiper-slider');
        let sliderOptions = sliderElement.getAttribute('data-slider');
        let thumbBtnPrev = document.querySelector('.thumb-button-prev');
        let thumbBtnNext = document.querySelector('.thumb-button-next');
        let thumbSlider;
        let windowSize = window.innerWidth;
        sliderOptions = JSON.parse(sliderOptions);
        
        // Set up nav slider
        if (sliderElement.hasAttribute('data-nav')) {
            let thumbSlider = document.querySelector('.' + sliderElement.getAttribute('data-nav'));
            if (!thumbSlider) {
                return;
            }
            let thumbSliderOptions = thumbSlider.getAttribute('data-slider');
            const slides = thumbSlider.querySelectorAll('.swiper-slide');
            const numSlides = slides.length;
            // Check the number of slides
            if (6 > numSlides) {
                if (thumbBtnPrev && thumbBtnNext){
                    thumbBtnPrev.classList.add('button_none');
                    thumbBtnNext.classList.add('button_none');
                }
            }
            // thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);
            sliderOptions.thumbs = {
                swiper: thumbSlider,
                autoScrollOffset: 0
            }

            sliderOptions.on = {
                init: (event) => {
                    setTimeout(() => {
                        window.dispatchEvent(new Event("resize"))
                    }, 100);
                    const currentTarget = event.el;
                    if (currentTarget.classList.contains('product-carousel')) {
                        const activeSlide = currentTarget.getElementsByClassName('swiper-slide')[event.activeIndex];
                        if (activeSlide && activeSlide.querySelector('custom-video') != null) {
                            let customVideo = activeSlide.querySelector('custom-video');
                            customVideo.toggleView();
                        }
                    }
                }
            }
        }
        let slider = new Swiper(sliderElement, sliderOptions);
        if (sliderElement.hasAttribute('data-nav')) {
          // 1. turn it ON at the start of every prev transition
          slider.on('slidePrevTransitionStart', () => {
            slider.params.thumbs.autoScrollOffset = 1;   // make rail jump sooner
          });

          // 2. turn it OFF again the moment the transition ends
          slider.on('slideNextTransitionStart',   () => {
            if(slider.activeIndex == 3){
              slider.params.thumbs.autoScrollOffset = 1;   // back to normal
            }
            else{
              slider.params.thumbs.autoScrollOffset = 0;   // back to normal
            }
          });

        }
        slider.on('slideChange', (event) => {
            slider.pagination.update();
            const currentTarget = event.el;
            if (currentTarget.querySelectorAll('custom-video.show--video').length > 0 || currentTarget.querySelectorAll('iframe').length > 0) {
              let customActiveVideo;
              let youtube = 0;
                if(currentTarget.querySelectorAll('iframe').length > 0) {
                  customActiveVideo = currentTarget.querySelectorAll('iframe');
                  youtube = 1;
                }
                else{
                  customActiveVideo = currentTarget.querySelectorAll('custom-video.show--video') || currentTarget.querySelectorAll('iframe');
                }
                customActiveVideo.forEach((video) => {
                    let videoType = video.getAttribute('data-video-type');
                    let videoEle = video.querySelector('video') || video.querySelector('iframe');
                    if(video.querySelector('video') === null){
                      videoEle = video;
                    }
                    if (videoType == 'local') {
                        videoEle.pause();
                    } else if (videoType == 'youtube' || youtube == 1) {
                        videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                    } else {
                        video.toggleView();
                    }
                });
            }
        });

        if (sliderElement.classList.contains('pdp-carousel')) {
            productSlider = slider;
        }
        
        if (sliderElement.hasAttribute('data-nav') && thumbSlider) {
            thumbSlider.controller.control = slider;
        }

    }
}
customElements.define('slider-element', sliderElement);/**
 * Manage Newsletter Popup based on Cookie
 *
 */
(function manageNewsletter() {
    const customerPosted = (window.location.href.search('[?&]customer_posted=true') !== -1);
    const $newsletterPopup = document.querySelector('#PopupModal-newsletter .modal');

    if (!$newsletterPopup) {
        return;
    }

    const popupDelay = $newsletterPopup.dataset.popup_delay * 1000;
    const daysUntil = $newsletterPopup.dataset['period_until'];
    const newsletterPopupEnabled = $newsletterPopup.dataset['newsletter_enabled'] == "false" ? false : true;
    const newsletterPopupStatus = Utility.getCookie('newsletter_popup_status');
    const today = new Date();
    const expirationDate = new Date();
    expirationDate.setDate(today.getDate() + daysUntil);
    const time = expirationDate.getTime();
    const expireTime = time + 1000 * 36000;
    expirationDate.setTime(expireTime);

    // after registration get the 'customer_posted' parameter from URL
    // show popup after successful registration
    // the popup will have the 'Thank you' message after registration redirection
    if (customerPosted) {
        $newsletterPopup.classList.add('open');
    }

    let newsletterCloseBtn = document.querySelector('[data-newsletter-close-btn]');
    if (newsletterCloseBtn) {
        newsletterCloseBtn.addEventListener('click', () => {
            document.cookie = `newsletter_popup_status=disabled;expires=${expirationDate.toGMTString()};path=/`;
            $newsletterPopup.classList.remove('open');
        });
    }

    // do not show the popup if the disabled status cookie exists
    if (newsletterPopupStatus === 'disabled' || !newsletterPopupEnabled) {
        return;
    }

    setTimeout(() => {
        $newsletterPopup.classList.add('open');
    }, popupDelay);
})();/**
 * Manage Custom Notification Trigger
 *
 */
class Notification extends HTMLElement {
    constructor() {
        super();

        this.paused = false;
        this.container = this.querySelector('.snotifyToast');
        this.closeBtn = this.querySelector('.snotifyToast__close');

        this.container.addEventListener('mouseover', (event) => {
            this.paused = true;
        });
        this.container.addEventListener('mouseout', (event) => {
            this.paused = false;
        });

        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.container.classList.remove('open');
                this.querySelector('.snotifyToast__title').innerHTML = '';
                this.querySelector('.snotifyToast__body').innerHTML = '';
                this.container.classList.remove('snotify-warning,snotify-info,snotify-error,snotify-success');
                this.querySelector('[data-toast-pr]').removeAttribute('style');
            });
        }
    }

    updateNotification(title, body, options) {
        document.querySelector('[data-snotifyToast]').className = '';
        this.querySelector('.snotifyToast__title').innerHTML = title;
        this.querySelector('.snotifyToast__body').innerHTML = body;
        if (options.type == 'error') {
            document.querySelector('[data-snotifyToast]').className = 'snotifyToast snotify-error';
        } else if (options.type == 'warning') {
            document.querySelector('[data-snotifyToast]').className = 'snotifyToast snotify-warning';
        } else if (options.type == 'info') {
            document.querySelector('[data-snotifyToast]').className = 'snotifyToast snotify-info';
        } else if (options.type == 'success') {
            document.querySelector('[data-snotifyToast]').className = 'snotifyToast snotify-success';
        }

        document.querySelector('[data-snotifyToast]').classList.add('open');
        this.manageToggle(options.timeout)
    }

    manageToggle(timeout) {
        this.progressBar = this.querySelector('[data-toast-pr]');
        let unit = parseInt(timeout) / 1000;
        unit = 100 / unit;
        let width = 0;

        let interval = setInterval(() => {
            if (this.paused == false) {
                width += unit;
                this.progressBar.setAttribute('style', `width: ${width}%`);
                if (width > 100) {
                    this.closeBtn.dispatchEvent(new Event('click'));
                    clearInterval(interval);
                }
            }
        }, 1000)
    }
}
customElements.define("custom-notification", Notification);
window.notificationEle = document.querySelector('custom-notification');const subAccordions = document.querySelectorAll('.toggle-sub-menu');
subAccordions.forEach((menuIcon) => {
    menuIcon.addEventListener('click', (e) => {
        const parentElement = e.target.closest('.sub_dropdown');
        if (parentElement.classList.contains('open')) {
            Utility.toggleElement(parentElement, 'close');
        } else {
            Utility.toggleElement(parentElement, 'open');
        }
    });
});

/**
 * Poster Video Autoplay
 *
 */

(function managePosterVideos() {
    let posterVideos = document.querySelectorAll('[data-postervideo]');
    if (posterVideos.length > 0) {
        posterVideos.forEach((video) => {
            let mobileSrc = video.getAttribute('data-mobileSrc');
            let windowSize = window.innerWidth || document.documentElement.clientWidth;

            if (windowSize < 768 && mobileSrc != null && mobileSrc != undefined) {
                video.querySelector('source').src = mobileSrc;
            }
            const onIntersection = (entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        if (entry.target) entry.target.play();
                        observer.disconnect();
                    }
                }
            };
            const observer = new IntersectionObserver(onIntersection);
            if (video != undefined) observer.observe(video);
        });
    }
})();

if (document.querySelectorAll('.product-thumb--image').length > 0) {
    document.querySelectorAll('.product-thumb--image').forEach(function (target) {
        target.addEventListener('click', (event) => {
            event.preventDefault();
            setTimeout(function () {
                document.querySelectorAll('.product-thumb--image').forEach(function (targetT) {
                    targetT.classList.remove('swiper-slide-thumb-active');
                });
                target.classList.add('swiper-slide-thumb-active');
            }, 200);
            var swiper = new Swiper('.product-carousel');
            swiper.slideTo(event.target.closest('.product-thumb--image').getAttribute('data-index'));
        });
    });
}



const klaviyoURL = "https://a.klaviyo.com/ajax/subscriptions/subscribe"; // TODO: rename to other than URL and uncomment line 95 in subscription-funnel.js

const getListKey = (listId) => `klaviyo_signed_${listId}`;

const getStoredList = (listId) => window.localStorage.getItem(getListKey(listId));

const storeSignupEvent = (listId) => {
  const exists = getStoredList(listId);
  if (!exists) window.localStorage.setItem(getListKey(listId), "true");
};

async function subscribe(email, listId, params = {}) {
  if (!listId) return console.error("Please provide a list id");
  const config = Object.assign({}, params, {
    g: listId,
    $email: email,
    $fields: "resonates_with,$email,services,$timezone_offset",
    $source: "Web Page",
    $timezone_offset: new Date().getTimezoneOffset() / -60,
    services: '{"shopify":{"source":"form"}}',
  });

  const body = Object.keys(config).reduce((str, key) => {
    str.append(key, config[key]);
    return str;
  }, new URLSearchParams());

  try {
    const res = await fetch(klaviyoURL, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
      },
      body,
    });
    const jsonRes = await res.json();
    if (!jsonRes.errors.length) storeSignupEvent(listId);
    return jsonRes;
  } catch (err) {
    console.error(err);
  }
}

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
window.subscribe = subscribe;

async function setupKlaviyoNewsletterForms() {
  const newsletterEls = document.querySelectorAll("[data-newsletter-signup]");

  newsletterEls.forEach((formWrapper) => {
    const formEl = formWrapper.querySelector("form");
    const successMessageEl = formWrapper.querySelector("[data-newsletter-success]");
    const errorMessageEl = formWrapper.querySelector("[data-newsletter-error]");
    const listId = formEl.getAttribute("data-list-id");
    const emailEL = formEl.querySelector('[data-newsletter-email]')
    const inputsEls = formEl.querySelectorAll("input");
    formEl.addEventListener("submit", async (e) => {
      e.preventDefault();
      let data = {};
      inputsEls.forEach((input) => {
        data[input.name] = input.value;
      });
      if (!data.email) {
        inputsEls.forEach(item => item.classList.add('error'));
        errorMessageEl.innerHTML = `<svg class="me-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.72413 15.0001C0.956311 15.0001 0.474944 14.1706 0.855891 13.5039L7.13271 2.51949C7.51661 1.84767 8.4853 1.84767 8.8692 2.51949L15.146 13.5039C15.527 14.1706 15.0456 15.0001 14.2778 15.0001L1.72413 15.0001ZM8.75095 9.75C8.75095 10.1642 8.41517 10.5 8.00095 10.5C7.58674 10.5 7.25095 10.1642 7.25095 9.75L7.25095 6.25C7.25095 5.83579 7.58674 5.5 8.00095 5.5C8.41517 5.5 8.75095 5.83579 8.75095 6.25V9.75ZM7.25095 12.25C7.25095 11.8358 7.58674 11.5 8.00095 11.5C8.41517 11.5 8.75095 11.8358 8.75095 12.25C8.75095 12.6642 8.41517 13 8.00095 13C7.58674 13 7.25095 12.6642 7.25095 12.25Z" fill="#FF0C00"/>
        </svg>
          Hmm, something doesn’t seem right...`;
        successMessageEl.classList.add('d-none');
        errorMessageEl.classList.remove('d-none');
        return;
      }

      if (validateEmail(data.email) === false) {
        errorMessageEl.innerHTML = `<svg class="me-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.72413 15.0001C0.956311 15.0001 0.474944 14.1706 0.855891 13.5039L7.13271 2.51949C7.51661 1.84767 8.4853 1.84767 8.8692 2.51949L15.146 13.5039C15.527 14.1706 15.0456 15.0001 14.2778 15.0001L1.72413 15.0001ZM8.75095 9.75C8.75095 10.1642 8.41517 10.5 8.00095 10.5C7.58674 10.5 7.25095 10.1642 7.25095 9.75L7.25095 6.25C7.25095 5.83579 7.58674 5.5 8.00095 5.5C8.41517 5.5 8.75095 5.83579 8.75095 6.25V9.75ZM7.25095 12.25C7.25095 11.8358 7.58674 11.5 8.00095 11.5C8.41517 11.5 8.75095 11.8358 8.75095 12.25C8.75095 12.6642 8.41517 13 8.00095 13C7.58674 13 7.25095 12.6642 7.25095 12.25Z" fill="#FF0C00"/>
        </svg>Please enter a valid email`;
        successMessageEl.classList.add('d-none');
        errorMessageEl.classList.remove('d-none');
        return;
      }

      const response = await subscribe(data.email, listId);
      // Klaviyo answers { success, errors: [] }. An empty array is truthy, so the
      // old `if (response.errors)` showed the success panel on every outcome,
      // including a rejected address or a network failure (which returns undefined).
      const subscribed = !!response && Array.isArray(response.errors) && response.errors.length === 0;

      if (!subscribed) {
        errorMessageEl.innerHTML = `<svg class="me-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.72413 15.0001C0.956311 15.0001 0.474944 14.1706 0.855891 13.5039L7.13271 2.51949C7.51661 1.84767 8.4853 1.84767 8.8692 2.51949L15.146 13.5039C15.527 14.1706 15.0456 15.0001 14.2778 15.0001L1.72413 15.0001ZM8.75095 9.75C8.75095 10.1642 8.41517 10.5 8.00095 10.5C7.58674 10.5 7.25095 10.1642 7.25095 9.75L7.25095 6.25C7.25095 5.83579 7.58674 5.5 8.00095 5.5C8.41517 5.5 8.75095 5.83579 8.75095 6.25V9.75ZM7.25095 12.25C7.25095 11.8358 7.58674 11.5 8.00095 11.5C8.41517 11.5 8.75095 11.8358 8.75095 12.25C8.75095 12.6642 8.41517 13 8.00095 13C7.58674 13 7.25095 12.6642 7.25095 12.25Z" fill="#FF0C00"/>
        </svg>Sorry, that didn’t go through. Please try again.`;
        successMessageEl.classList.add('d-none');
        errorMessageEl.classList.remove('d-none');
        return;
      }

      emailEL.value = "";
      errorMessageEl.classList.add('d-none');
      formEl.style.display = "none";
      successMessageEl.classList.remove('d-none');

      // Analytics listens for this rather than reading the response itself, so
      // every dataLayer push keeps going through one module. See ga4-tracking.js.
      document.dispatchEvent(new CustomEvent("cl:newsletter-signup", {
        detail: { listId: listId, form: formWrapper },
      }));
    });
  });
}

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('a[data-smooth-scroll]');
  if (!trigger) return;

  event.preventDefault();
  const targetEl = document.querySelector('#subscription-comparison');
  if (!targetEl) return;

  const headerEl = document.querySelector('.site-header');
  const computedOffset = headerEl ? headerEl.offsetHeight : 0;
  const offsetAttr = trigger.dataset.scrollOffset;
  const extraOffset = offsetAttr && !isNaN(offsetAttr) ? Number(offsetAttr) : 0;
  const targetTop = targetEl.getBoundingClientRect().top + window.pageYOffset - computedOffset + extraOffset;
  window.scrollTo({ top: targetTop, behavior: 'smooth' });
});

document.addEventListener('DOMContentLoaded', function() {
  setupKlaviyoNewsletterForms();

  const videoElements = document.querySelectorAll('video');
    videoElements.forEach(video => {
        // Add event listeners for error handling
        video.addEventListener('error', (event) => {
            console.error('Video playback error:', event);
            // Optionally load fallback content or message
        });
        // Attempt to play the video manually in Instagram WebView
        video.setAttribute('playsinline', 'true');
        video.play().catch(err => {
            console.error('Autoplay failed:', err);
        });
    });
});
